export default __webpack_public_path__ + "static/media/adminIndex.22a6a58b.less";